import { type SortTypes } from '@web-platform/shared-universal-constants/src/sort';

import { translate } from '../translate';

type ItineraryCountTranslator = {
  SINGLE: () => string; // 1 result sorted by {SortType}
  MULTIPLE: (totalItineraries: number) => string; // X results sorted by {SortType}
  // X of Y results sorted by {SortType}
  FILTERED: (filteredItineraries: number, totalItineraries: number) => string;
};

const itineraryCountTranslators: Record<SortTypes, ItineraryCountTranslator> = {
  BEST: {
    SINGLE: () => translate('label_result_sorted_by_best'),
    MULTIPLE: (totalItineraries: number) =>
      translate('label_results_sorted_by_best', { X: totalItineraries }),
    FILTERED: (filteredItineraries: number, totalItineraries: number) =>
      translate('label_filtered_results_sorted_by_best', {
        totalNumberItineraries: totalItineraries,
        numVisibleItineraries: filteredItineraries,
      }),
  },
  CHEAPEST: {
    SINGLE: () => translate('label_result_sorted_by_cheapest'),
    MULTIPLE: (totalItineraries: number) =>
      translate('label_results_sorted_by_cheapest', { X: totalItineraries }),
    FILTERED: (filteredItineraries: number, totalItineraries: number) =>
      translate('label_filtered_results_sorted_by_cheapest', {
        totalNumberItineraries: totalItineraries,
        numVisibleItineraries: filteredItineraries,
      }),
  },
  FASTEST: {
    SINGLE: () => translate('label_result_sorted_by_fastest'),
    MULTIPLE: (totalItineraries: number) =>
      translate('label_results_sorted_by_fastest', { X: totalItineraries }),
    FILTERED: (filteredItineraries: number, totalItineraries: number) =>
      translate('label_filtered_results_sorted_by_fastest', {
        totalNumberItineraries: totalItineraries,
        numVisibleItineraries: filteredItineraries,
      }),
  },
  DEPARTURE_OUTBOUND_ASC: {
    SINGLE: () => translate('label_result_sorted_by_outbound_departure'),
    MULTIPLE: (totalItineraries: number) =>
      translate('label_results_sorted_by_outbound_departure', { X: totalItineraries }),
    FILTERED: (filteredItineraries: number, totalItineraries: number) =>
      translate('label_filtered_results_sorted_by_outbound_departure', {
        totalNumberItineraries: totalItineraries,
        numVisibleItineraries: filteredItineraries,
      }),
  },
  DEPARTURE_INBOUND_ASC: {
    SINGLE: () => translate('label_result_sorted_by_return_departure'),
    MULTIPLE: (totalItineraries: number) =>
      translate('label_results_sorted_by_return_departure', { X: totalItineraries }),
    FILTERED: (filteredItineraries: number, totalItineraries: number) =>
      translate('label_filtered_results_sorted_by_return_departure', {
        totalNumberItineraries: totalItineraries,
        numVisibleItineraries: filteredItineraries,
      }),
  },
};

export function getItineraryCountText(
  selectedSort: SortTypes,
  totalItineraries: number,
  filteredItineraries: number,
): string {
  const translator = itineraryCountTranslators[selectedSort];

  if (totalItineraries !== filteredItineraries) {
    return translator.FILTERED(filteredItineraries, totalItineraries);
  }
  if (totalItineraries === 1) {
    return translator.SINGLE();
  }
  return translator.MULTIPLE(totalItineraries);
}
